let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bFEDY")).then(() => parcelRequire('iWPaH'));